var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"hiq-assignments__list-header"},[_vm._v("Tjänst")]),(_vm.assignmentList.length)?_c('ul',{staticClass:"hiq-assignments__list"},_vm._l((_vm.assignmentList),function(item,index){return _c('AssignmentItemMobile',{key:item.id,attrs:{"item":item,"index":index}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }